const PREFIX = 'spot-ls-';
const AUTH_KEYS = ['token', 'lastRequestTime'];

function saveToLS(data) {
  Object.keys(data).forEach((key) => {
    if (data[key]) {
      localStorage.setItem(PREFIX + key, data[key]); // Save only keys with a value
    }
  });
}

function deleteFromLS(keys) {
  keys.forEach((k) => {
    localStorage.removeItem(PREFIX + k);
  });
}

function getQueryStringVar(key) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) === key) {
      return decodeURIComponent(pair[1]);
    }
  }
  return '';
}

export function saveAuthToken(token) {
  saveToLS({ token });
}

export function deleteAuthData() {
  deleteFromLS(AUTH_KEYS);
}

export function getCurrentToken() {
  return localStorage.getItem(`${PREFIX}token`);
}

export function getTokenFromQueryString() {
  return getQueryStringVar('t');
}



// WEBPACK FOOTER //
// ./client/app/services/auth.js